export default function IconAddLocation() {
  return (
   <svg version="1.1" id="fi_731545" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 512 512" style={{enableBackground:"new 0 0 512 512"}} space="preserve">
<g>
	<g>
		<path d="M192,0C86.112,0,0,86.112,0,192c0,133.088,173.312,307.936,180.672,315.328C183.808,510.432,187.904,512,192,512
			s8.192-1.568,11.328-4.672c2.176-2.176,19.136-19.36,41.664-45.536C232,438.656,224,412.384,224,384
			c0-87.2,69.824-157.792,156.576-159.648C382.592,213.376,384,202.528,384,192C384,86.112,297.888,0,192,0z M192,288
			c-52.928,0-96-43.072-96-96s43.072-96,96-96c52.928,0,96,43.072,96,96C288,244.928,244.928,288,192,288z"></path>
	</g>
</g>
<g>
	<g>
		<path d="M384,256c-70.688,0-128,57.312-128,128s57.312,128,128,128s128-57.312,128-128S454.688,256,384,256z M432,400h-32v32
			c0,8.832-7.168,16-16,16c-8.832,0-16-7.168-16-16v-32h-32c-8.832,0-16-7.168-16-16c0-8.832,7.168-16,16-16h32v-32
			c0-8.832,7.168-16,16-16c8.832,0,16,7.168,16,16v32h32c8.832,0,16,7.168,16,16C448,392.832,440.832,400,432,400z"></path>
	</g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
</svg>
  );
}
